import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomAlert from '../components/CustomAlert';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function FaceVerifyResult() {
  const query = useQuery();
  const responseStr = query.get('response');
  const orderCode = query.get('orderCode'); // 直接从URL参数获取订单号
  const [isSignFile, setIsSignFile] = useState(false);
  const [status, setStatus] = useState('查询中...');
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ open: false, message: '', type: 'info' });

  // 解析 response，获取 certifyId
  let certifyId = null;
  if (responseStr) {
    try {
      const responseObj = JSON.parse(decodeURIComponent(responseStr));
      certifyId = responseObj?.extInfo?.certifyId;
      // console.log('前端解析的 responseObj:', responseObj);
      // console.log('前端解析出的 certifyId:', certifyId);
    } catch (e) {
      console.error('前端解析 response 失败:', e);
      setAlert({
        open: true,
        message: '解析认证结果失败，请重新进行认证',
        type: 'error'
      });
    }
  }

  useEffect(() => {
    // console.log('FaceVerifyResult 组件参数:', { responseStr, certifyId });
    if (certifyId) {
      // 首先触发后端处理认证结果
      // console.log('触发后端处理认证结果:', certifyId);
      fetch(`/api/face/aliyun/notify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ CertifyId: certifyId })
      })
        .then(res => res.json())
        .then(data => {
          console.log('后端处理认证结果返回:', data);
          // 然后查询认证状态
          return fetch(`/api/face/queryResult?certify_id=${certifyId}`);
        })
        .then(res => res.json())
        .then(data => {
          console.log('后端返回结果:', data);
          setLoading(false);
          if (data.code === 0) {
            const passed = data.face_status === '认证通过';
            const hasFile = !!data.isSignFile;

            // 统一展示结果页面，由用户决定后续操作
            setIsSignFile(hasFile);
            setStatus(passed ? '认证通过' : '认证失败');
          } else {
            setStatus('查询失败');
            setAlert({
              open: true,
              message: '查询失败：' + (data.msg || '未知错误'),
              type: 'error'
            });
          }
        })
        .catch(err => {
          console.error('前端请求失败:', err);
          setLoading(false);
          setStatus('网络错误');
          setAlert({
            open: true,
            message: '网络连接失败，请检查网络后重试',
            type: 'error'
          });
        });
    } else {
      console.log('certifyId 为空');
      setLoading(false);
      setStatus('未获取到认证信息');
      setAlert({
        open: true,
        message: '未获取到认证信息，请重新进行认证',
        type: 'error'
      });
    }
  }, [certifyId]);

  const getStatusIcon = () => {
    if (loading) return '⏳';
    //if (status === '认证通过') return '✅';
    if (status === '认证通过') return <img src="/icon-ls.png" alt="重庆章网绿色图标（章网绿盾）" width="170px"  height="170px"/>;
    if (status === '认证失败') return <span style={{ fontSize: '100px', lineHeight: 1, display: 'block', marginBottom: '16px' }}>❌</span>;
    return '❓';
  };

  const getStatusColor = () => {
    if (loading) return '#6c757d';
    if (status === '认证通过') return '#28a745';
    if (status === '认证失败') return '#dc3545';
    return '#ffc107';
  };

  const getStatusBg = () => {
    if (loading) return '#f8f9fa';
    if (status === '认证通过') return '#d4edda';
    if (status === '认证失败') return '#f8d7da';
    return '#fff3cd';
  };

  const getStatusBorder = () => {
    if (loading) return '#e9ecef';
    if (status === '认证通过') return '#c3e6cb';
    if (status === '认证失败') return '#f5c6cb';
    return '#ffeaa7';
  };

  return (
    <>
      <div style={{
        maxWidth: '500px',
        margin: '40px auto',
        padding: '0 20px'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          border: '1px solid #e9ecef',
          textAlign: 'center'
        }}>
         {getStatusIcon()}
             <h2 style={{
            color: '#2c3e50',
            margin: '0 0 16px 0',
            fontSize: '18px',
            fontWeight: '700'
          }}>
            人脸识别结果如下：
          </h2>

          {loading && (
            <div style={{
              background: getStatusBg(),
              border: `2px solid ${getStatusBorder()}`,
              borderRadius: '12px',
              padding: '24px',
              marginBottom: '32px'
            }}>
              <div style={{
                fontSize: '14px',
                color: '#6c757d',
                marginTop: '8px'
              }}>
                正在查询认证结果，请稍候...
              </div>
            </div>
          )}

          {!loading && (
            <>
              <div style={{
                background: getStatusBg(),
                border: `2px solid ${getStatusBorder()}`,
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '32px'
              }}>
                <div style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: getStatusColor(),
                  marginBottom: '8px'
                }}>
                  人脸{status}
                </div>
                {status === '认证通过' && (
                  <div style={{
                    fontSize: '20px',
                    color: '#155724',
                    marginTop: '8px'
                  }}>
                  <div style={{
                    fontSize: '20px',
                    color: getStatusColor(),
                    fontWeight: '600',
                    marginTop: '-8px'
                 }}>
                  但流程还未全部完成
                 </div>
                    请点击【文件签章】按钮，进入下一步操作。
                  </div>
                )}
                {status === '认证失败' && (
                  <div style={{
                    fontSize: '20px',
                    color: '#721c24',
                    marginTop: '8px'
                  }}>
                    如需继续办理，请重新进行认证。
                  </div>
                )}
              </div>

              <div style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>
                {status === '认证通过' && isSignFile && (
                  <>
                    <button
                      onClick={() => {
                        if (isSignFile) {
                          const urlParams = new URLSearchParams(window.location.search);
                          const responseStr = urlParams.get('response');
                          if (responseStr) {
                            const responseObj = JSON.parse(decodeURIComponent(responseStr));
                            const certifyId = responseObj?.extInfo?.certifyId;
                            if (certifyId) {
                              window.location.href = `/sign-before?certifyId=${certifyId}`;
                              return;
                            }
                          }
                        }
                      }}
                      style={{
                        background: 'var(--primary-color)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        fontWeight: '500',
                        minWidth: '120px'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = 'var(--primary-hover)';
                        e.target.style.transform = 'translateY(-1px)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = 'var(--primary-color)';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      同意办理 我要签名
                    </button>
                    <button
                      onClick={() => {
                        window.location.href = '/';
                      }}
                      style={{
                        background: 'var(--primary-color)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        fontWeight: '500',
                        minWidth: '120px'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = 'var(--primary-hover)';
                        e.target.style.transform = 'translateY(-1px)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = 'var(--primary-color)';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      不同意
                    </button>
                  </>
                )}
                {status === '认证通过' && (
                    <>
                      <button
                          onClick={() => {
                              const urlParams = new URLSearchParams(window.location.search);
                              const responseStr = urlParams.get('response');
                              if (responseStr) {
                                const responseObj = JSON.parse(decodeURIComponent(responseStr));
                                const certifyId = responseObj?.extInfo?.certifyId;
                                if (certifyId) {
                                  window.location.href = `/sign-before?certifyId=${certifyId}`;
                                  return;
                                }
                              }
                          }}
                          style={{
                            background: 'var(--primary-color)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 24px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            fontWeight: '500',
                            minWidth: '120px'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = 'var(--primary-hover)';
                            e.target.style.transform = 'translateY(-1px)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = 'var(--primary-color)';
                            e.target.style.transform = 'translateY(0)';
                          }}
                      >
                        文件签章
                  </button>
                  <button
                      onClick={async () => {
                        try {
                          // 从URL参数获取response并解析certifyId
                          const urlParams = new URLSearchParams(window.location.search);
                          const responseStr = urlParams.get('response');

                          if (responseStr) {
                            const responseObj = JSON.parse(decodeURIComponent(responseStr));
                            const certifyId = responseObj?.extInfo?.certifyId;

                            if (certifyId) {
                              // 通过certifyId查询订单信息
                              const res = await fetch(`/api/face/getOrderByCertifyId?certify_id=${certifyId}`);
                              const data = await res.json();

                              if (data.success && data.query && data.code) {
                                // 构建正确的查询URL
                                const queryParam = encodeURIComponent(data.query);
                                const redirectUrl = `/?orderCode=${queryParam}&code=${data.code}`;
                                console.log('构建的跳转URL:', redirectUrl);
                                console.log('返回的数据:', data);
                                window.location.href = redirectUrl;
                                return;
                              }
                            }
                          }

                          // 如果无法获取订单信息，回到主页
                          window.location.href = '/';
                        } catch (error) {
                          console.error('获取订单信息失败:', error);
                          window.location.href = '/';
                        }
                      }}
                    style={{
                      background: 'var(--primary-color)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '12px 24px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      fontWeight: '500',
                      minWidth: '120px'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'var(--primary-hover)';
                      e.target.style.transform = 'translateY(-1px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'var(--primary-color)';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    取消认证
                  </button>
                  </>
                )}
                {status === '认证失败' && (
                  <>
                    <button
                      onClick={async () => {
                        try {
                          // 从URL参数获取response并解析certifyId
                          const urlParams = new URLSearchParams(window.location.search);
                          const responseStr = urlParams.get('response');

                          if (responseStr) {
                            const responseObj = JSON.parse(decodeURIComponent(responseStr));
                            const certifyId = responseObj?.extInfo?.certifyId;

                            if (certifyId) {
                              // 通过certifyId查询订单信息
                              const res = await fetch(`/api/face/getOrderByCertifyId?certify_id=${certifyId}`);
                              const data = await res.json();

                              if (data.success && data.query && data.code) {
                                // 构建正确的查询URL
                                const queryParam = encodeURIComponent(data.query);
                                const redirectUrl = `/?orderCode=${queryParam}&code=${data.code}`;
                                console.log('构建的跳转URL:', redirectUrl);
                                console.log('返回的数据:', data);
                                window.location.href = redirectUrl;
                                return;
                              }
                            }
                          }

                          // 如果无法获取订单信息，回到主页
                          window.location.href = '/';
                        } catch (error) {
                          console.error('获取订单信息失败:', error);
                          window.location.href = '/';
                        }
                      }}
                      style={{
                        background: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        fontWeight: '500',
                        minWidth: '120px'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = '#c82333';
                        e.target.style.transform = 'translateY(-1px)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = '#dc3545';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      重新认证
                    </button>

                    <button
                      onClick={() => window.location.href = '/'}
                      style={{
                        background: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        fontWeight: '500',
                        minWidth: '120px'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = '#5a6268';
                        e.target.style.transform = 'translateY(-1px)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = '#6c757d';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      退出登录
                    </button>
                  </>
                )}
              </div>
            </>
          )}

          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef',
            textAlign: 'left'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <span style={{ fontSize: '16px', marginRight: '8px' }}>ℹ️</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                说明
              </span>
            </div>
            <p style={{
              margin: '0',
              textAlign: 'center',
              fontSize: '13px',
              color: '#6c757d',
              lineHeight: '1.5'
            }}>
              认证结果已实时更新到系统，如有疑问请联系相关业务人员。
            </p>
          </div>
        </div>
      </div>

      <CustomAlert
        open={alert.open}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </>
  );
}
